import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=42b2f96d&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"
import style0 from "./Notification.vue?vue&type=style&index=0&id=42b2f96d&prod&lang=css&"
import style1 from "./Notification.vue?vue&type=style&index=1&id=42b2f96d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b2f96d",
  null
  
)

export default component.exports